import { marketEntry } from "@/showcases/market-entry";
import { onboardingFlow } from "@/showcases/onboarding-flow";
import { uploadSystem } from "@/showcases/upload-system";

export const showcases = [onboardingFlow, uploadSystem, marketEntry] as const;

export function getShowcase(slug: string) {
  return showcases.find((showcase) => showcase.slug === slug) ?? null;
}
